import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { DrawingTools } from '@shared/drawing/drawing';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-draw',
  imports: [
    NgbTooltip,
    ButtonComponent
  ],
  templateUrl: './viewer-draw.component.html',
  styleUrl: './viewer-draw.component.scss'
})
export class ViewerDrawComponent implements AfterViewInit {
  @Input() enabled = false;
  @Output() activeDrawingTool = new EventEmitter<DrawingTools>();
  activeTool: DrawingTools = DrawingTools.none;
  penIsActive = false;
  eraserIsActive = false;
  tooltipText = '';

  protected readonly zbpIconNames = zbpIconNames;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    if (this.enabled) {
      this.tooltipText = '';
    } else {
      this.tooltipText = 'Drawing tools are not available for this item.';
    }

    this.cdRef.detectChanges();
  }

  setActiveTool(toolName: string): void {
    if (this.activeTool === DrawingTools[toolName]) {
      this.activeTool = DrawingTools.none;
    } else {
      this.activeTool = DrawingTools[toolName];
    }

    this.penIsActive = this.activeTool === DrawingTools.draw;
    this.eraserIsActive = this.activeTool === DrawingTools.erase;

    this.activeDrawingTool.emit(this.activeTool);
  }

}
